import React from "react";
import { useTranslation } from "react-i18next";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Switch from '@material-ui/core/Switch';

const AI_FEATURES = [
  {
    key: "visitImageScoringEnabled",
    labelKey: "instances.ai.fields.visitImageScoringEnabled.label"
  }
];

const AIInstance = ({ values, setFieldValue }) => {
  const { t } = useTranslation("instances");
  const aiFeatures = values.aiFeatures || {};

  return (
    <List>
      {AI_FEATURES.map(({ key, labelKey }) => (
        <ListItem key={key}>
          <ListItemText primary={t(labelKey)} />
          <ListItemSecondaryAction>
            <Switch
              checked={aiFeatures[key] === true}
              onChange={(event) => {
                setFieldValue(`aiFeatures.${key}`, event.target.checked);
              }}
              color="primary"
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export default AIInstance;
